import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class ZoneInventoryModel extends BaseAPIModel {
    static list(item) {
        return item;
    }

    static listUrl({ organizationId, chartId, inventoryId }) {
        if (!organizationId || !chartId || !inventoryId) {
            throw new ArgumentError(`[Model][ZoneInventory][listUrl] organizationId, chartId and inventoryId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/charts/${chartId}/inventories/${inventoryId}/zones`;
    }
}
